export const UPDATE_PASSWORD_BEGIN = 'UPDATE_PASSWORD_BEGIN';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR';
export const CLEAR_PASSWORD_DATA = 'CLEAR_PASSWORD_DATA';
